export class BranchServiceType {
  constructor(branchServiceType = {}) {
    this.serviceTypeId = branchServiceType.service_type_id;
    this.mobility = branchServiceType.mobility;
    this.capacity = branchServiceType.capacity;
  }
}
